import React from "react";
import { NavLink } from "react-router-dom";
import { Scissors, Folder, Film } from "lucide-react";

// Horizontal tab strip that groups the three video-workflow pages together
// (Cut Clips → Library → Weekly Reel). Consolidates what used to be three
// separate sidebar items into a single logical "Replay" section.
export default function ReplayTabs() {
  const tabs = [
    { to: "/replay", label: "Cut Clips", icon: Scissors, testid: "replay-tab-cut" },
    { to: "/library", label: "Library", icon: Folder, testid: "replay-tab-library" },
    { to: "/reel", label: "Weekly Reel", icon: Film, testid: "replay-tab-reel" },
  ];
  return (
    <div
      className="flex items-center gap-1 px-8 pt-6"
      data-testid="replay-tabs"
    >
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end
          data-testid={t.testid}
          className={({ isActive }) =>
            `flex items-center gap-2 px-4 py-2 text-xs font-medium tracking-wide rounded-md transition-colors ${
              isActive
                ? "bg-[color:var(--accent)] text-white"
                : "text-[color:var(--fg-3)] hover:text-[color:var(--fg)] hover:bg-[color:var(--surface)]"
            }`
          }
        >
          <t.icon className="h-3.5 w-3.5" strokeWidth={1.75} />
          <span>{t.label}</span>
        </NavLink>
      ))}
    </div>
  );
}
